import { showCustomImageMobile } from 'globalCommon/utils/index';
import { syncRender } from 'globalCommon/services/syncRender';
import commonPageService from 'mCommon/services/commonPageService';
import { UserLogoMap } from '../common/utils/imageSource';
import './style.css';

function init() {
    showCustomImageMobile(UserLogoMap, 'show-logo');
    commonPageService({ renderAfter: syncRender });
}

init();
